// extracted by mini-css-extract-plugin
export default {"styleHeading":"ElementOrder__styleHeading___2w7uj","printButton":"ElementOrder__printButton___10N3V","printFlyoutSubHeading":"ElementOrder__printFlyoutSubHeading___2T4-Y"};